module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/founder_doctor/arc_md-6fc7ce9b00a51ec814f7f92406747641.svg";